import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function ListasHoobuyPage() {
  return <BlogArticleLayout slug="listas-hoobuy-atualizadas-2026" />;
}